<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="pay">
        <!-- 微导航 -->
        <div class="wnav">
          <span>课程体系</span> >
          <span>全部课程</span> >
          <span>全部课程</span> >
          <span class="gengduo">支付</span>
        </div>
        <div class="inform" v-for="(list,index) in lists" :key="index">
          <div class="pay-inform">支付信息</div>
          <div class="pay-detail">
            <img :src="list.image" alt />
            <div>
              <div class="title">{{list.name}}</div>
              <div class="price">￥{{list.price}}</div>
            </div>
          </div>
          <div class="mode">选择支付方式</div>
          <div class="Choice">
            <div
              class="zfb"
              v-for="(tab,index) in tabs"
              :key="index"
              @click="toggle(index,tab.view,tab.id)"
              :class="{active:active==index}"
            >
              <img :src="tab.img" alt />
              <div>
                {{tab.type}}
                <span v-if="tab.type==`余额支付`">{{list.money}}</span>
              </div>
            </div>
          </div>
          <div class="service">如在支付过程中出现异常，请联系官方客服021-20905777(工作时间:9:00-18:00)，我们将为您处理。</div>
          <div class="select">
            <input id="chkSignIn" v-model="xz" type="checkbox" name="agreement" />
            <div>
              我已阅读并同意
              <span class="agree" @click="goxy(1)">《知会教育中心用户协议》</span>
            </div>
          </div>
          <div class="btn" @click="payment(list)">确认支付</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <!--这里是半透明背景层-->
    <div class="over" v-show="popup!=1"></div>
    <el-button round v-show="popup!=1" @click="closepopup" class="over1">取消支付</el-button>
    <div v-show="popup!=1" id="qrCode" ref="qrCodeDiv"></div>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
import QRCode from "qrcodejs2";
export default {
  name: "pay",
  inject: ["reload"],
  data() {
    return {
      active: 0,
      currentView: "tab1",
      tabs: [
        {
          type: "支付宝支付",
          img: "../../static/img/zfb.png",
          view: "tab1",
          id: "5",
        },
        {
          type: "微信支付",
          img: "../../static/img/wechat1.png",
          view: "tab2",
          id: "7",
        },
        {
          type: "余额支付",
          view: "tab3",
          id: "3",
        },
      ],
      id: "",
      order_id: "",
      lists: [],
      xz: false,
      pay_type: "5",
      cont: "",
      popup: "1",
    };
  },
  created() {
    var id = this.$route.query.id;
    var order_id = this.$route.query.order_id;
    this.id = id;
    this.order_id = order_id;
  },
  methods: {
    //  tab切换
    toggle(i, v, p) {
      this.active = i;
      this.currentView = v;
      this.pay_type = p;
    },
    // 支付信息
    async course_detail_pc() {
      var uid = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .course_detail_pc({ course_id: this.id, uid: uid.id })
        .then((res) => {
          console.log(res.data.content);
          if (res.data.code == 200) {
            // this.banner1 = res.data.content;
            this.lists.push(res.data.content);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //确认支付
    async payment(list) {
      if (this.pay_type == 7) {
        this.test = setInterval(() => {
          this.if_pay();
        }, 2000);
      }
      var uid = JSON.parse(sessionStorage.getItem("data"));
      if (this.xz) {
        await this.$service.home
          .diaoqi({
            uid: uid.id,
            order_id: this.order_id,
            pay_type: this.pay_type,
            qr_pay_mode: "0",
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 200) {
              // 支付宝跳转
              if (res.data.msg == "请求成功") {
                let routerData = this.$router.resolve({
                  path: "/payGateWay",
                  query: { htmlData: res.data.content },
                });
                // 打开新页面
                window.open(routerData.href, "_ blank");
              }
              // 微信支付
              if (res.data.msg == "success") {
                new QRCode(this.$refs.qrCodeDiv, {
                  text: res.data.content,
                  width: 200,
                  height: 200,
                  colorDark: "#333333", //二维码颜色
                  colorLight: "#ffffff", //二维码背景色
                  correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
                });
                this.popup = 2;
              }
              // 余额支付
              if (res.data.msg == "成功") {
                this.$router.push({
                  path: "/pay_success",
                  query: {
                    order_id: this.order_id,
                    num: "1", //用来判断支付详情
                  },
                });
              }
            } else {
              this.$confirm(res.data.msg)
                .then((_) => {
                  done();
                })
                .catch((_) => {});
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$confirm("请同意《知会教育中心使用协议》")
          .then((_) => {
            done();
          })
          .catch((_) => {});
      }
    },
    closepopup() {
      this.popup = 1;
      this.reload();
      // 清除定时器
      clearInterval(this.test);
      this.test = null;
    },
    // 订单是否支付
    async if_pay() {
      var uid = JSON.parse(sessionStorage.getItem("data"));
      await this.$service.home
        .if_pay({
          uid: uid.id,
          order_id: this.order_id,
        })
        .then((res) => {
          console.log(res.data.content);
          if (res.data.content == 1) {
            this.$notify({
              title: "成功",
              message: "支付成功",
              type: "success",
            });
            this.$router.push({
              path: "/pay_success",
              query: {
                order_id: this.order_id,
                num: "1", //用来判断支付详情
              },
            });
            // 清除定时器
            clearInterval(this.test);
            this.test = null;
          }
        });
    },
    // 协议
    goxy(i) {
      this.$router.push({
        path: "/xy",
        query: {
          id: i,
        },
      });
    },
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.course_detail_pc();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#qrCode {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.over1 {
  position: fixed;
  left: 50%;
  top: 68%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
/* 微导航 */
.background .pay {
  width: 1200px;
  margin: 0 auto;
}
.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.pay .inform {
  width: 1200px;
  height: 828px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.pay .inform .pay-inform {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin: 25px 0 28px 20px;
}
.pay .inform .pay-detail {
  width: 580px;
  height: 133px;
  background: rgba(249, 252, 255, 1);
  display: flex;
  justify-content: space-around;
  margin: 25px 0 40px 20px;
  padding: 18px 0 15px 16px;
}
.pay .inform .pay-detail img {
  width: 150px;
  height: 100px;
}
.pay .inform .pay-detail .title {
  width: 374px;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  margin-bottom: 28px;
}
.pay .inform .pay-detail .price {
  width: 81px;
  height: 30px;
  font-size: 22px;
  font-weight: 500;
  color: rgba(255, 83, 91, 1);
  line-height: 30px;
}
.pay .inform .mode {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin: 0 0 15px 20px;
}
.pay .inform .Choice {
  display: flex;
  justify-content: space-around;
  width: 500px;
  margin: 0 0 15px 20px;
}
.pay .inform .Choice .zfb {
  min-width: 135px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(207, 207, 207, 1);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.pay .inform .Choice .zfb.active {
  border: 1px solid #1775ef;
}
.pay .inform .service {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 28px;
  margin: 0 0 85px 20px;
}
.pay .inform .select {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 18px;
  margin: 0 0 15px 20px;
  display: flex;
}
.pay .inform .select img {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.pay .inform .select .agree {
  color: #1775ef;
}
.pay .inform .btn {
  width: 154px;
  height: 44px;
  background: rgba(23, 117, 239, 1);
  border-radius: 22px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  text-align: center;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue